var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"planner-dashboard"}},[_c('header',[_c('fm-text',{attrs:{"tag":"h1"}},[_vm._v("Planner")])],1),_c('main',{staticClass:"planner-main"})])}
var staticRenderFns = []

export { render, staticRenderFns }